import { FC } from "react"
import { COLORS } from "shared/consts"

type FiltersIconProps = {
  fill?: string
}

export const FiltersIcon: FC<FiltersIconProps> = ({
  fill
}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.91663 7.08334C7.91663 8.00381 7.17043 8.75 6.24996 8.75C5.32948 8.75 4.58329 8.00381 4.58329 7.08334C4.58329 6.16286 5.32948 5.41667 6.24996 5.41667C7.17043 5.41667 7.91663 6.16286 7.91663 7.08334ZM6.24996 10C7.64626 10 8.81339 9.01883 9.09951 7.70834L18.3333 7.70834L18.3333 6.45834L9.0995 6.45834C8.81339 5.14784 7.64626 4.16667 6.24996 4.16667C4.85366 4.16667 3.68653 5.14785 3.40041 6.45834H1.66663V7.70834H3.40041C3.68653 9.01883 4.85366 10 6.24996 10ZM10.9004 13.125L1.66663 13.125V14.375L10.9004 14.375C11.1865 15.6855 12.3537 16.6667 13.75 16.6667C15.1463 16.6667 16.3134 15.6855 16.5995 14.375H18.3333V13.125H16.5995C16.3134 11.8145 15.1463 10.8333 13.75 10.8333C12.3537 10.8333 11.1865 11.8145 10.9004 13.125ZM15.4166 13.75C15.4166 14.6705 14.6704 15.4167 13.75 15.4167C12.8295 15.4167 12.0833 14.6705 12.0833 13.75C12.0833 12.8295 12.8295 12.0833 13.75 12.0833C14.6704 12.0833 15.4166 12.8295 15.4166 13.75Z" fill={fill || COLORS.NEUTRAL.DEFAULT}/>
    </svg>
  )
}